export default __webpack_public_path__ + "static/Big-Pineapple-Promo-Packet-78732e0931f30a99ee5ccb1afec121f0.pdf";